import SharedNavbar from '@/components/feature/SharedNavbar';
import { Seo } from '@/components/Seo';
import SharedFooter from '@/components/feature/SharedFooter';
import { useTranslation } from 'react-i18next';
import { useSiteDesign } from '@/hooks/useSiteDesign';
import AboutV2 from '@/pages/info/v2/AboutV2';

export default function AboutPage() {
  const { isNew } = useSiteDesign();
  return isNew ? <AboutV2 /> : <ClassicAboutPage />;
}

function ClassicAboutPage() {
  const { t } = useTranslation();

  const pillars = [
    { num: '01', title: t('about.values.pillar1.title'), desc: t('about.values.pillar1.desc') },
    { num: '02', title: t('about.values.pillar2.title'), desc: t('about.values.pillar2.desc') },
    { num: '03', title: t('about.values.pillar3.title'), desc: t('about.values.pillar3.desc') },
  ];

  return (
    <>
      <main className="w-full min-h-screen bg-white font-sans">
        <Seo pageKey="about" />
        <SharedNavbar />

        {/* ===== HERO ===== */}
        <section className="w-full bg-[#1A1A1A] pt-28 pb-16 md:pt-32 md:pb-20 px-6 md:px-12 lg:px-20">
          <div className="max-w-7xl mx-auto text-center">
            <div className="flex items-center justify-center gap-3 mb-5">
              <div className="w-6 h-px bg-[#7B1113]" />
              <span className="text-[11px] tracking-[0.2em] uppercase text-[#7B1113] font-medium">
                {t('about.hero.label')}
              </span>
              <div className="w-6 h-px bg-[#7B1113]" />
            </div>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.15] mb-4">
              {t('about.hero.heading')}
            </h1>
            <p className="text-sm text-white/40 font-light max-w-lg mx-auto">
              {t('about.hero.subtitle')}
            </p>
          </div>
        </section>

        {/* ===== CONTENT ===== */}
        <section className="w-full bg-white py-16 md:py-24 px-6 md:px-12 lg:px-20">
          <div className="max-w-3xl mx-auto flex flex-col gap-10">
            <div>
              <h2 className="font-serif text-2xl font-bold text-[#2A2A2A] mb-4">{t('about.story.heading')}</h2>
              <p className="text-sm text-[#5A5A5A] font-light leading-[1.9] mb-4">
                {t('about.story.p1')}
              </p>
              <p className="text-sm text-[#5A5A5A] font-light leading-[1.9]">
                {t('about.story.p2')}
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl font-bold text-[#2A2A2A] mb-4">{t('about.mission.heading')}</h2>
              <p className="text-sm text-[#5A5A5A] font-light leading-[1.9]">
                {t('about.mission.body')}
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              {pillars.map((item) => (
                <div key={item.num} className="bg-[#F0EFED] rounded-2xl p-6 flex flex-col gap-3">
                  <span className="text-[10px] tracking-[0.15em] uppercase text-[#7B1113] font-medium">{item.num}</span>
                  <h3 className="font-serif text-lg font-bold text-[#2A2A2A]">{item.title}</h3>
                  <p className="text-sm text-[#8A8A8A] font-light leading-[1.7]">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="border border-[#E8E8E6] rounded-2xl p-6 md:p-8">
              <h2 className="font-serif text-2xl font-bold text-[#2A2A2A] mb-4">{t('about.company.heading', 'Company Information')}</h2>
              <div className="flex flex-col gap-2 text-sm text-[#5A5A5A] font-light leading-[1.9]">
                <p>{t('about.company.siteDesc', 'Rx.K Seoul (rxk.thekseoul.com) is an e-commerce website operated for the online sale of Rx.K Seoul dermocosmetic skincare products in Bangladesh.')}</p>
                <p>{t('about.company.concern', 'The.K Seoul is a business concern of Sol Grace Construction BD. Ltd.')}</p>
                <p>{t('about.company.entity', 'Sol Grace Construction BD. Ltd.')}</p>
                <p>{t('about.company.bin', 'BIN: 009212412-0108')}</p>
                <p>{t('about.company.tin', 'TIN: 520132321674')}</p>
                <p>{t('about.company.address', 'Address: 2/2-A, South Begunbari, Tejgaon I/A, Dhaka-1208, Bangladesh')}</p>
                <p>{t('about.company.tradeLicense', 'Trade License: TRAD/DNCC/027028/2025')}</p>
              </div>
            </div>
          </div>
        </section>

        <SharedFooter />
      </main>
    </>
  );
}